import React from "react";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/userProfileApproval/OpenItem.css';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import Button from '../../shared/Button';
import PreviewModal from '../../shared/PreviewDocument';
import SuccessModal from '../../shared/SuccessModal';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { profileBaseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { USERPROFILEAPPROVAL, DOWNLOAD_ENDPOINT, SINGLEPROFILEAPPROVAL } from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import Cookies from 'cookies-js';
import Loader from 'react-loader';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let viewOnly = false;
var pageDisable = false;
var loaderTime = false;
const urlPath = utilityBaseURL + DOWNLOAD_ENDPOINT + "?documentPath=";
var decodeCIPCImage = "";
let hasOpenImagePreview = false;
class OpenItem extends React.Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            requesterDropdown: false,
            respondentDropdown: false,
            driverDropdown: false,
            requesterAction: "",
            respondentAction: "",
            driverAction: "",
            requesterComments: "",
            respondentComments: "",
            driverComments: "",
            requesterTextLimit: 0,
            respondentTextLimit: 0,
            driverTextLimit: 0,
            hasOpenImagePreview: false,
            confirmedHasOpen: false,
            roleType: '',
            roleName: '',
            fullName: '',
            mobileNumber: '',
            companyName: '',
            companyRegistrationNumber: '',
            companyDocument: '',
            vatRegisteredFlag: '',
            vatNumber: '',
            vatDocument: '',
            physicalAddressLine1: '',
            physicalAddressLine2: '',
            physicalAddressCity: '',
            physicalAddressProvince: '',
            physicalAddressCountryName: '',
            physicalAddressPostalCode: '',
            postalAddressLine1: '',
            postalAddressLine2: '',
            postalAddressCity: '',
            postalAddressProvince: '',
            postalAddressCountryName: '',
            postalAddressPostalCode: '',
            bankAccountName: '',
            bankAccountNumber: '',
            branchName: '',
            branchCode: '',
            bankAddress: '',
            bankAccountDocument: '',
            citizenship: '',
            idType: '',
            idNumber: '',
            idDocument: '',
            driverCountry: '',
            driverIdExpiryDate: '',
            drivingLicenceNumber: '',
            drivingExpiryDate: '',
            drivingDocument: '',
            drivingIssueCountry: '',
            cipcDocument: '',
            vatDocumentPreview: '',
            bankDocument: '',
            passportDocument: '',
            drivingLicenceDocument: ''
        }
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        console.log(window.screen.width)
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 14) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        console.log(this.props.taskId, this.props?.taskId)
        ApiCall(
            'GET',
            profileBaseURL + SINGLEPROFILEAPPROVAL + `/${this.props.taskId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    console.log(data, data.map((i, index) => (
                        data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                    )))
                    console.log(data)
                    this.setState({
                        roleType: data[0]?.taskData.profileUpdateRequest.profileRole.roleType,
                        roleName: data[0]?.taskData.profileUpdateRequest.profileRole.roleName,
                        fullName: data[0]?.taskData.profileUpdateRequest.firstName + " " + data[0]?.taskData.profileUpdateRequest.lastName,
                        mobileNumber: data[0]?.taskData.profileUpdateRequest.mobileNumber,
                        companyName: data[0]?.taskData.profileUpdateRequest.companyDetails?.companyName,
                        companyRegistrationNumber: data[0]?.taskData.profileUpdateRequest.companyDetails?.registrationNumber,
                        companyDocument: data[0]?.taskData.profileUpdateRequest.companyDetails?.companyDocument?.documentName,
                        vatRegisteredFlag: data[0]?.taskData.profileUpdateRequest.companyDetails?.vatRegisteredFlag,
                        vatNumber: data[0]?.taskData.profileUpdateRequest.companyDetails?.vatNumber,
                        vatDocument: data[0]?.taskData.profileUpdateRequest.companyDetails?.vatDocument.documentName,
                        physicalAddressLine1: data[0]?.taskData.profileUpdateRequest.physicalAddress?.addressline1,
                        physicalAddressLine2: data[0]?.taskData.profileUpdateRequest.physicalAddress?.addressline2,
                        physicalAddressCity: data[0]?.taskData.profileUpdateRequest.physicalAddress?.city,
                        physicalAddressProvince: data[0]?.taskData.profileUpdateRequest.physicalAddress?.province,
                        physicalAddressCountryName: data[0]?.taskData.profileUpdateRequest.physicalAddress?.countryName,
                        physicalAddressPostalCode: data[0]?.taskData.profileUpdateRequest.physicalAddress?.postalCode,
                        postalAddressLine1: data[0]?.taskData.profileUpdateRequest.postalAddress?.addressline1,
                        postalAddressLine2: data[0]?.taskData.profileUpdateRequest.postalAddress?.addressline2,
                        postalAddressCity: data[0]?.taskData.profileUpdateRequest.postalAddress?.city,
                        postalAddressProvince: data[0]?.taskData.profileUpdateRequest.postalAddress?.province,
                        postalAddressCountryName: data[0]?.taskData.profileUpdateRequest.postalAddress?.countryName,
                        postalAddressPostalCode: data[0]?.taskData.profileUpdateRequest.postalAddress?.postalCode,
                        bankAccountName: data[0]?.taskData.profileUpdateRequest.bankDetails?.accountName,
                        bankAccountNumber: data[0]?.taskData.profileUpdateRequest.bankDetails?.bankAccountNumber,
                        branchName: data[0]?.taskData.profileUpdateRequest.bankDetails?.branchName,
                        branchCode: data[0]?.taskData.profileUpdateRequest.bankDetails?.branchCode,
                        bankAddress: data[0]?.taskData.profileUpdateRequest.bankDetails?.bankAddress,
                        bankAccountDocument: data[0]?.taskData.profileUpdateRequest.bankDetails?.accountDocument?.documentName,
                        idType: data[0]?.taskData.profileUpdateRequest.identityDetails?.idType,
                        idNumber: data[0]?.taskData.profileUpdateRequest.identityDetails?.idNumber,
                        idDocument: data[0]?.taskData.profileUpdateRequest.identityDetails?.idDocument?.documentName,
                        driverCountry: data[0]?.taskData.profileUpdateRequest.identityDetails?.country,
                        driverIdExpiryDate: this.getDate(data[0]?.taskData.profileUpdateRequest.identityDetails?.expiryDate),
                        drivingLicenceNumber: data[0]?.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingLicenceNo,
                        drivingExpiryDate: this.getDate(data[0]?.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingExpiryDate),
                        drivingDocument: data[0]?.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument?.documentName,
                        drivingIssueCountry: data[0]?.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingIssueCountry,
                        cipcDocument: data[0]?.taskData.profileUpdateRequest.companyDetails?.companyDocument.documentPicture,
                        vatDocumentPreview: data[0]?.taskData.profileUpdateRequest.companyDetails?.vatDocument.documentPicture,
                        bankDocument: data[0]?.taskData.profileUpdateRequest.bankDetails?.accountDocument.documentPicture,
                        passportDocument: data[0]?.taskData.profileUpdateRequest?.identityDetails?.idDocument.documentPicture,
                        drivingLicenceDocument: data[0]?.taskData.profileUpdateRequest.drivingLicenseDetails?.drivingDocument.documentPicture,
                        citizenship: data[0]?.taskData.profileUpdateRequest.identityDetails?.idType == "Passport" ? "Foreign Driver / Non-Resident" : "South African Citizen / Resident"
                    })
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ requesterDropdown: false });
            this.setState({ respondentDropdown: false });
            this.setState({ driverDropdown: false });
        }
    };
    handleCancle = () => {
        window.location.replace('/#UserProfile')
    }
    toggleRequesterDropdown = () => {
        this.setState({ requesterDropdown: !this.state.requesterDropdown });
    }
    toggleRespondentDropdown = () => {
        this.setState({ respondentDropdown: !this.state.respondentDropdown });
    }
    toggleDriverDropdown = () => {
        this.setState({ driverDropdown: !this.state.driverDropdown });
    }
    selectRequesterAction = (e) => {
        this.setState({ requesterAction: e.target.innerText });
        this.setState({ requesterDropdown: false });
    }
    selectRespondentAction = (e) => {
        this.setState({ respondentAction: e.target.innerText });
        this.setState({ respondentDropdown: false });
    }
    selectDriverAction = (e) => {
        this.setState({ driverAction: e.target.innerText });
        this.setState({ driverDropdown: false });
    }
    validateRequesterFormFields = () => {
        return this.state.requesterComments.length > 0 && this.state.requesterAction.length > 0;
    };
    validateRespondentFormFields = () => {
        return this.state.respondentComments.length > 0 && this.state.respondentAction.length > 0;
    };
    validateDriverFormFields = () => {
        return this.state.driverComments.length > 0 && this.state.driverAction.length > 0;
    };
    handleRequesterComments = (e) => {
        if (e.target.value.length <= 150) {
            this.setState({ requesterTextLimit: e.target.value.length });
            this.setState({ requesterComments: e.target.value });
        }
    }
    handleRespondentComments = (e) => {
        if (e.target.value.length <= 150) {
            this.setState({ respondentTextLimit: e.target.value.length });
            this.setState({ respondentComments: e.target.value });
        }
    }
    handleDriverComments = (e) => {
        if (e.target.value.length <= 150) {
            this.setState({ driverTextLimit: e.target.value.length });
            this.setState({ driverComments: e.target.value });
        }
    }
    submitRequesterProfile = () => {
        ApiCall(
            'POST',
            profileBaseURL + USERPROFILEAPPROVAL + `?approved=${this.state.requesterAction == "Approve" ? true : false}&comments=${this.state.requesterComments}&taskId=${this.props.taskId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ confirmedHasOpen: true });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    submitRespondentProfile = () => {
        ApiCall(
            'POST',
            profileBaseURL + USERPROFILEAPPROVAL + `?approved=${this.state.respondentAction == "Approve" ? true : false}&comments=${this.state.respondentComments}&taskId=${this.props.taskId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ confirmedHasOpen: true });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    submitDriverProfile = () => {
        ApiCall(
            'POST',
            profileBaseURL + USERPROFILEAPPROVAL + `?approved=${this.state.driverAction == "Approve" ? true : false}&comments=${this.state.driverComments}&taskId=${this.props.taskId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ confirmedHasOpen: true });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    onPreviewCIPCDocument = () => {
        pageDisable = true;
        loaderTime = true;
        this.previewCipc();
    }
    previewCipc = () => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.cipcDocument.split('/')[11].split("'")[0].split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.cipcDocument;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.cipcDocument;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeCIPCImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                hasOpenImagePreview = true;
            };
            xhr.send();
        }
    }
    onPreviewVATDocument = () => {
        pageDisable = true;
        loaderTime = true;
        this.previewVat();
    }
    previewVat = () => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.vatDocumentPreview.split('/')[11].split("'")[0].split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.vatDocumentPreview;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.vatDocumentPreview;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeCIPCImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                hasOpenImagePreview = true;
            };
            xhr.send();
        }
    }
    onPreviewBankDocument = () => {
        pageDisable = true;
        loaderTime = true;
        this.previewBankDetails();
    }
    previewBankDetails = () => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.bankDocument.split('/')[11].split("'")[0].split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.bankDocument;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.bankDocument;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeCIPCImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                hasOpenImagePreview = true;
            };
            xhr.send();
        }
    }
    onPreviewPassportDocument = () => {
        pageDisable = true;
        loaderTime = true;
        this.previewPassport();
    }
    previewPassport = () => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.passportDocument.split('/')[11].split("'")[0].split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.passportDocument;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.passportDocument;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeCIPCImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                hasOpenImagePreview = true;
            };
            xhr.send();
        }
    }
    onPreviewDrivingDocument = () => {
        pageDisable = true;
        loaderTime = true;
        this.previewDrivingLicense();
    }
    previewDrivingLicense = () => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        if (this.state.drivingLicenceDocument.split('/')[11].split("'")[0].split(".")[1] == "pdf") {
            var oReq = new XMLHttpRequest();
            // var URLToPDF = res.url;
            var URLToPDF = urlPath + this.state.drivingLicenceDocument;
            oReq.open("GET", URLToPDF, true);
            oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            oReq.responseType = "blob";
            oReq.onload = function () {
                // Once the file is downloaded, open a new window with the PDF
                // Remember to allow the POP-UPS in your browser
                const file = new Blob([oReq.response], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                pageDisable = false;
                loaderTime = false;
                window.open(fileURL, "_blank");
            };
            oReq.send();
        }
        else {
            var xhr = new XMLHttpRequest();
            var URLToImage = urlPath + this.state.drivingLicenceDocument;
            // var URLToImage =urlPath+name;
            xhr.open("GET", URLToImage, true);
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                //    window.open(imageUrl);
                // var img = document.querySelector( "#photo" );
                // img.src = imageUrl;
                // decodeImage[index] = imageUrl;
                decodeCIPCImage = imageUrl
                console.log("decode url", imageUrl);
                pageDisable = false;
                loaderTime = false;
                hasOpenImagePreview = true;
                // window.open(imageUrl);
            };
            xhr.send();
        }
    }
    onClosePreviewModal = () => {
        hasOpenImagePreview = false;
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.replace('/#UserProfile');
    }
    getDate = (timeStamp) => {
        let date = new Date(timeStamp).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    render() {
        return (
            <div className="outer1" id={pageDisable ? "disabletrue" : ""}><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.openItemPageTitle} description={TitleDescription.openItemPageDescription} />
                <Loader
                    loaded={!loaderTime}
                    lines={10}
                    length={10}
                    width={10}
                    radius={10}
                    corners={1}
                    rotate={0}
                    direction={1}
                    color="#000"
                    speed={1}
                    trail={60}
                    shadow={false}
                    hwaccel={false}
                    className='spinner'
                    zIndex={2e9}
                    top="50%"
                    left="50%"
                    scale={1.0}
                    loadedClassName="loadedContent"
                />
                <div className="openItemhome">

                    <SideNav />
                    <div id="openItemPart">
                        <h1 id='userProfiletitle'>User Profile Approval</h1>
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        {
                            (this.state.roleType === "Requester" || this.state.roleName === "Requester" || this.state.roleType === "Requestor" || this.state.roleName === "Requestor") &&
                            <div className="openItemcontentbox">
                                <div>
                                    <div className="personNmaeDiv">
                                        <p className="personName">{this.state.fullName}</p>
                                    </div>
                                    <hr className="personNameBorderbottom" />
                                </div>
                                <div id='openItemdetails'>
                                    <div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Mobile</p>
                                                <p className="userData">{this.state.mobileNumber}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">Role Type</p>
                                                <p className="userData">{this.state.roleType}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Role Name</p>
                                                <p className="userData">{this.state.roleName}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Company Information</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Company Name</p>
                                                <p className="userData">{this.state.companyName}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">Company Registration Number</p>
                                                <p className="userData">{this.state.companyRegistrationNumber}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">CIPC Statement (Not older than 3 months)</p>
                                                <p className="fileData" onClick={this.onPreviewCIPCDocument}>{this.state.companyDocument}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading"
                                        // style={{display: this.state.vatRegisteredFlag == "false" ? "flex" : "none"}}
                                        >
                                            <p className="dataHeadingText">VAT Information</p>
                                        </div>
                                        <div className="basicInfo"
                                        // style={{display: this.state.vatRegisteredFlag == "false" ? "flex" : "none"}}
                                        >
                                            <div className="firstColumn">
                                                <p className="dataLabel">VAT Registration Number</p>
                                                <p className="userData">{this.state.vatNumber !== '' ? this.state.vatNumber : "NA"}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">VAT Registration Certificate</p>
                                                {this.state.vatDocument !== '' ? <p className="fileData" onClick={this.onPreviewVATDocument}>{this.state.vatDocument}</p> : <p className="userData">NA</p>}
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Physical Address</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 1</p>
                                                <p className="userData">{this.state.physicalAddressLine1}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 2 (Optional)</p>
                                                <p className="userData">{this.state.physicalAddressLine2}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">City</p>
                                                <p className="userData">{this.state.physicalAddressCity}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Province</p>
                                                <p className="userData">{this.state.physicalAddressProvince}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Country</p>
                                                <p className="userData">{this.state.physicalAddressCountryName}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Postal Code</p>
                                                <p className="userData">{this.state.physicalAddressPostalCode}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Postal Address</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 1</p>
                                                <p className="userData">{this.state.postalAddressLine1}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 2 (Optional)</p>
                                                <p className="userData">{this.state.postalAddressLine2}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">City</p>
                                                <p className="userData">{this.state.postalAddressCity}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Province</p>
                                                <p className="userData">{this.state.postalAddressProvince}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Country</p>
                                                <p className="userData">{this.state.postalAddressCountryName}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Postal Code</p>
                                                <p className="userData">{this.state.postalAddressPostalCode}</p>
                                            </div>
                                        </div>

                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Bank Details</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Account Name</p>
                                                <p className="userData">{this.state.bankAccountName}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Account Number</p>
                                                <p className="userData">{this.state.bankAccountNumber}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Branch Name (Optional)</p>
                                                <p className="userData">{this.state.branchName}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Branch Code</p>
                                                <p className="userData">{this.state.branchCode}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Bank Address</p>
                                                <p className="userData">{this.state.bankAddress}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Bank Account Confirmation Letter</p>
                                                <p className="fileData" onClick={this.onPreviewBankDocument}>{this.state.bankAccountDocument}</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="userActionContainer" style={{ display: !viewOnly ? "none" : null }}>
                                        <div className="userbasicInfo">
                                            <div className="firstColumn">
                                                <p className="selectAction">Select Action</p>
                                                {<div>
                                                    <input type="text" className="actionDropdown" value={this.state.requesterAction} placeholder="- - Select - -" />
                                                    <img class="pl-2 pr-2" onClick={this.toggleRequesterDropdown} src={arrow} alt="Second slide" />
                                                </div>}
                                                {this.state.requesterDropdown && (
                                                    <div class="border" id="userActiondropdown" ref={this.container} >
                                                        <dl id="valueContainer">
                                                            <dt className="dropdownList" onClick={this.selectRequesterAction}>
                                                                <small class="p-1" class="dropdownValue">
                                                                    Approve
                                                        </small>
                                                            </dt>
                                                            <dt className="dropdownList" onClick={this.selectRequesterAction}>
                                                                <small class="p-1" class="dropdownValue">
                                                                    Reject
                                                        </small>
                                                            </dt>
                                                        </dl>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="secondPart">
                                                <p className="selectAction">Comments</p>
                                                {<div>
                                                    <textarea type="text" className="comments" value={this.state.requesterComments} onChange={this.handleRequesterComments} placeholder="Enter your comment" ></textarea>
                                                    <div className="textableContainer"><p className="textable">{this.state.requesterTextLimit}/150</p></div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="itemstableFooter">
                                    <div className="tableButtons">
                                        <Button type="cancel" class="cancelbutton" onClick={this.handleCancle}>Cancel</Button>
                                        <Button type="submit"
                                            disabled={!this.validateRequesterFormFields()}
                                            onClick={this.submitRequesterProfile}
                                            style={{ display: !viewOnly ? "none" : null }}
                                            class="submitbutton">Submit</Button>
                                    </div>
                                </div>
                            </div>}
                        {
                            (this.state.roleType === "Respondent" || this.state.roleName === "Respondent") &&
                            <div className="openItemcontentbox">
                                <div>
                                    <div className="personNmaeDiv">
                                        <p className="personName">{this.state.fullName}</p>
                                    </div>
                                    <hr className="personNameBorderbottom" />
                                </div>
                                <div id='openItemdetails'>

                                    <div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Mobile</p>
                                                <p className="userData">{this.state.mobileNumber}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">Role Type</p>
                                                <p className="userData">{this.state.roleType}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Role Name</p>
                                                <p className="userData">{this.state.roleName}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Company Information</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Company Name</p>
                                                <p className="userData">{this.state.companyName}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">Company Registration Number</p>
                                                <p className="userData">{this.state.companyRegistrationNumber}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">CIPC Statement (Not older than 3 months)</p>
                                                <p className="fileData" onClick={this.onPreviewCIPCDocument}>{this.state.companyDocument}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading"
                                        //  style={{display: this.state.vatRegisteredFlag == "false" ? "flex" : "none"}}
                                        >
                                            <p className="dataHeadingText">VAT Information</p>
                                        </div>
                                        <div className="basicInfo"
                                        // style={{display: this.state.vatRegisteredFlag == "false" ? "flex" : "none"}}
                                        >
                                            <div className="firstColumn">
                                                <p className="dataLabel">VAT Registration Number</p>
                                                <p className="userData">{this.state.vatNumber !== '' ? this.state.vatNumber : "NA"}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">VAT Registration Certificate</p>
                                                {this.state.vatDocument !== '' ? <p className="fileData" onClick={this.onPreviewVATDocument}>{this.state.vatDocument}</p> : <p className="userData">NA</p>}
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Physical Address</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 1</p>
                                                <p className="userData">{this.state.physicalAddressLine1}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 2 (Optional)</p>
                                                <p className="userData">{this.state.physicalAddressLine2}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">City</p>
                                                <p className="userData">{this.state.physicalAddressCity}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Province</p>
                                                <p className="userData">{this.state.physicalAddressProvince}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Country</p>
                                                <p className="userData">{this.state.physicalAddressCountryName}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Postal Code</p>
                                                <p className="userData">{this.state.physicalAddressPostalCode}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Postal Address</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 1</p>
                                                <p className="userData">{this.state.postalAddressLine1}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Address Line 2 (Optional)</p>
                                                <p className="userData">{this.state.postalAddressLine2}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">City</p>
                                                <p className="userData">{this.state.postalAddressCity}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Province</p>
                                                <p className="userData">{this.state.postalAddressProvince}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Country</p>
                                                <p className="userData">{this.state.postalAddressCountryName}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Postal Code</p>
                                                <p className="userData">{this.state.postalAddressPostalCode}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Bank Details</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Account Name</p>
                                                <p className="userData">{this.state.bankAccountName}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Account Number</p>
                                                <p className="userData">{this.state.bankAccountNumber}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Branch Name (Optional)</p>
                                                <p className="userData">{this.state.branchName}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Branch Code</p>
                                                <p className="userData">{this.state.branchCode}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Bank Address</p>
                                                <p className="userData">{this.state.bankAddress}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Bank Account Confirmation Letter</p>
                                                <p className="fileData" onClick={this.onPreviewBankDocument}>{this.state.bankAccountDocument}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="userActionContainer" style={{ display: !viewOnly ? "none" : null }}>
                                        <div className="userbasicInfo">
                                            <div className="firstColumn">
                                                <p className="selectAction">Select Action</p>
                                                {
                                                    <div>
                                                        <input type="text" className="actionDropdown" value={this.state.respondentAction} placeholder="- - Select - -" />
                                                        <img class="pl-2 pr-2" onClick={this.toggleRespondentDropdown} src={arrow} alt="Second slide" />
                                                    </div>
                                                }
                                                {this.state.respondentDropdown && (
                                                    <div class="border" id="userActiondropdown" ref={this.container} >
                                                        <dl id="valueContainer">
                                                            <dt className="dropdownList" onClick={this.selectRespondentAction}>
                                                                <small class="p-1" class="dropdownValue">
                                                                    Approve
                                                        </small>
                                                            </dt>
                                                            <dt className="dropdownList" onClick={this.selectRespondentAction}>
                                                                <small class="p-1" class="dropdownValue">
                                                                    Reject
                                                        </small>
                                                            </dt>
                                                        </dl>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="secondPart">
                                                <p className="selectAction">Comments</p>
                                                {<div>
                                                    <textarea type="text" className="comments" value={this.state.respondentComments} onChange={this.handleRespondentComments} placeholder="Enter your comment" ></textarea>
                                                    <div className="textableContainer"><p className="textable">{this.state.respondentTextLimit}/150</p></div></div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="itemstableFooter">
                                    <div className="tableButtons">
                                        <Button type="cancel" class="cancelbutton" onClick={this.handleCancle}>Cancel</Button>
                                        <Button type="submit"
                                            class="submitbutton"
                                            onClick={this.submitRespondentProfile}
                                            style={{ display: !viewOnly ? "none" : null }}
                                            disabled={!this.validateRespondentFormFields()}>Submit</Button>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            (this.state.roleType === "Driver" || this.state.roleName === "Driver") &&
                            <div className="openItemcontentbox">
                                <div>
                                    <div className="personNmaeDiv">
                                        <p className="personName">{this.state.fullName}</p>
                                    </div>
                                    <hr className="personNameBorderbottom" />
                                </div>
                                <div id='openItemdetails'>

                                    <div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Mobile</p>
                                                <p className="userData">{this.state.mobileNumber}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">Role Type</p>
                                                <p className="userData">{this.state.roleType}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Role Name</p>
                                                <p className="userData">{this.state.roleName}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">ID Information</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Citizenship</p>
                                                <p className="userData">{this.state.citizenship}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">{this.state.idType == "Passport" ? "Passport No." : "South African ID No"}</p>
                                                <p className="userData">{this.state.idNumber}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Document</p>
                                                <p className="fileData" onClick={this.onPreviewPassportDocument}>{this.state.idDocument}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Country of Issue</p>
                                                <p className="userData">{this.state.driverCountry}</p>
                                            </div>
                                            <div className="secondColumn">
                                                <p className="dataLabel">Expiry Date</p>
                                                <p className="userData">{this.state.driverIdExpiryDate}</p>
                                            </div>
                                        </div>
                                        <div className="dataHeading">
                                            <p className="dataHeadingText">Driving License Information</p>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Driving License No.</p>
                                                <p className="userData">{this.state.drivingLicenceNumber}</p>
                                            </div>
                                            <div className="firstColumn">
                                                <p className="dataLabel">Expiry Date</p>
                                                <p className="userData">{this.state.drivingExpiryDate}</p>
                                            </div>
                                            <div>
                                                <p className="dataLabel">Driving License Documente</p>
                                                <p className="fileData" onClick={this.onPreviewDrivingDocument}>{this.state.drivingDocument}</p>
                                            </div>
                                        </div>
                                        <div className="basicInfo">
                                            <div className="firstColumn">
                                                <p className="dataLabel">Country of Issue</p>
                                                <p className="userData">{this.state.drivingIssueCountry}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="userActionContainer" style={{ display: !viewOnly ? "none" : null }}>
                                        <div className="userbasicInfo">
                                            <div className="firstColumn">
                                                <p className="selectAction">Select Action</p>
                                                {<div>
                                                    <input type="text" className="actionDropdown" value={this.state.driverAction} onChange={this.selectDriverAction} placeholder="- - Select - -" />
                                                    <img class="pl-2 pr-2" onClick={this.toggleDriverDropdown} src={arrow} alt="Second slide" />
                                                </div>}
                                                {this.state.driverDropdown && (
                                                    <div class="border" id="userActiondropdown" ref={this.container} >
                                                        <dl id="valueContainer">
                                                            <dt className="dropdownList" onClick={this.selectDriverAction}>
                                                                <small class="p-1" class="dropdownValue">
                                                                    Approve
                                                        </small>
                                                            </dt>
                                                            <dt className="dropdownList" onClick={this.selectDriverAction}>
                                                                <small class="p-1" class="dropdownValue">
                                                                    Reject
                                                        </small>
                                                            </dt>
                                                        </dl>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="secondPart">
                                                <p className="selectAction">Comments</p>
                                                {<div><textarea type="text" className="comments" value={this.state.driverComments} onChange={this.handleDriverComments} placeholder="Enter your comment" ></textarea>
                                                    <div className="textableContainer"><p className="textable">{this.state.driverTextLimit}/150</p></div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="itemstableFooter">
                                    <div className="tableButtons">
                                        <Button type="cancel" class="cancelbutton" onClick={this.handleCancle}>Cancel</Button>
                                        <Button type="submit"
                                            class="submitbutton"
                                            onClick={this.submitDriverProfile}
                                            style={{ display: !viewOnly ? "none" : null }}
                                            disabled={!this.validateDriverFormFields()}
                                        >Submit</Button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {hasOpenImagePreview ?
                    <PreviewModal onClick={this.onClosePreviewModal}
                        profileData={decodeCIPCImage}
                    /> : null}
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return {
        data: state.adminRoleReducer.roleData,
        taskId: state.userProfileReducer.taskId
    }
}
export default connect(mapStateToProps)(OpenItem);